import { clsx } from 'clsx';
import { Text } from '@teachstonellc/component-library';
import { RadioGroup, RadioGroupItem } from '@radix-ui/react-radio-group';

const classes = clsx(
  'flex-1 text-center bg-ds-black-alpha-2 hover:bg-ds-black-alpha-3 cursor-pointer border-ds-border px-4 py-0.5',

  // Checked state styles
  'data-[state=checked]:border data-[state=checked]:bg-ds-fuschia-4 data-[state=checked]:border-ds-fuschia-6'
);

interface IndicatorScoreInputProps {
  value: string | null;
  onChange: (score: string) => void;
}

export function IndicatorScoreInput({
  value,
  onChange
}: IndicatorScoreInputProps) {
  return (
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className="flex items-center"
    >
      <RadioGroupItem
        value="0"
        className={clsx(classes, 'border-l border-y rounded-l-lg')}
      >
        <Text variant="label1" className="cursor-pointer">
          Low
        </Text>
      </RadioGroupItem>

      <RadioGroupItem value="50" className={clsx(classes, 'border')}>
        <Text variant="label1" className="cursor-pointer">
          Mid
        </Text>
      </RadioGroupItem>

      <RadioGroupItem
        value="100"
        className={clsx(classes, 'border-r border-y rounded-r-lg')}
      >
        <Text variant="label1" className="cursor-pointer">
          High
        </Text>
      </RadioGroupItem>
    </RadioGroup>
  );
}
